import React, { useCallback } from "react";
import Button from "@material-ui/core/Button";
import TextInput from "../../../FormElements/TextInput/TextInput";
import "./LoginPageForm.scss";

export const LoginPageForm = (props) => {
  const {
    values: { userId, userPhone },
    errors,
    touched,
    handleSubmit,
    handleChange,
    isValid,
    setFieldTouched,
  } = props;

  const change = useCallback(
    (name, e) => {
      e.persist();
      handleChange(e);
      setFieldTouched(name, true, false);
    },
    [handleChange, setFieldTouched]
  );

  return (
    <form
      className="loginForm"
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit}
    >
      <TextInput
        value={userId}
        id={"userId"}
        touched={touched}
        errors={errors}
        onChange={(event) => change("userId", event)}
        label={"תעודת זהות"}
      />

      <TextInput
        value={userPhone}
        id={"userPhone"}
        touched={touched}
        errors={errors}
        onChange={(event) => change("userPhone", event)}
        label={"מספר טלפון"}
      />

      <Button
        className="submitButton"
        type="submit"
        variant="contained"
        disabled={!isValid}
      >
        שלח
      </Button>
    </form>
  );
};
